var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicTabletDrawPen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.894 11.5L12.4232 13.6179C12.5991 14.3214 12.9629 14.9639 13.4756 15.4766L18.3777 20.3787C19.2066 21.2071 20.55 21.2071 21.3789 20.3787V20.3787C22.2073 19.5498 22.2073 18.2064 21.3789 17.3774L16.4769 12.4754C15.9641 11.9626 15.3216 11.5989 14.6181 11.423L12.5002 10.8937C12.3299 10.8513 12.1498 10.9013 12.0257 11.0254C11.9015 11.1495 11.8516 11.3297 11.894 11.5Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0038 11.9998V5.99734C21.0038 4.3398 19.6601 2.99609 18.0026 2.99609H5.99759C4.34004 2.99609 2.99634 4.3398 2.99634 5.99734V18.0023C2.99634 19.6599 4.34004 21.0036 5.99759 21.0036H14.0009",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicTabletDrawPen);
export default ForwardRef;